import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

/**
 * @method apiGetSurveyResult
 */

export default {
    apiGetSurveyResult: function() {
        const token = Account.getToken();
        const url = ConfigManager.getApiModuleUrl() + '/quiz/report';
        return BzbsApi.connectBzbsGet(url, token, null)
            .pipe(map((res) => {
                return res.data.data;
            }));
    },
    apiSubmitGoldenQuestion: function(params) {
        const token = Account.getToken();
        const url = ConfigManager.getApiModuleUrl() + '/quiz/create';
        return BzbsApi.connectBzbsPostJson(url, token, params)
            .pipe(map((res) => {
                return res.data.data;
            })); 
    }
}